// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__28ms_","newExpiryDate":"styles_newExpiryDate__2-7DL","footer":"styles_footer__2cj6q"};